import { isValueANumber } from './number-utils';

export const parseRequiredId = (id: string | string[] | undefined | null): number | null => {
  if (!id || Array.isArray(id)) {
    return null;
  }
  const parsedId = parseInt(id, 10);

  return isValueANumber(parsedId) ? parsedId : null;
};
